import {PulseIcon} from '@primer/octicons-react'
import {Box, Octicon, Text} from '@primer/react'

const defaultHeading = `No activity matched your search.`
const defaultDescription = `Try expanding your search by selecting a different branch, activity type, user, or timeframe.`

export function ActivityBlankSlate({
  heading = defaultHeading,
  description = defaultDescription,
}: {
  heading?: string
  description?: string
}) {
  return (
    <Box className="blankslate">
      <Octicon icon={PulseIcon} size={24} />
      <h2 className="blankslate-heading">{heading}</h2>
      <Text as="p">{description}</Text>
    </Box>
  )
}

try{ ActivityBlankSlate.displayName ||= 'ActivityBlankSlate' } catch {}